import { em } from 'polished'
import styled from 'styled-components'

import { Row, Col } from 'styles/components/layout'
import { TextLH } from 'styles/components/typography'

export const PhoneFieldColWrapper = styled(Col)`
  display: flex;
`

export const BoxPhone = styled.div`
  flex-grow: 1;
  margin-right: ${p => (p.noMargin ? 0 : em(20))};
`

export const RowStyled = styled(Row)`
  position: relative;
`

export const ColStyled = styled(Col)`
  margin-top: ${em(40)};
`

export const RulesWrapper = styled.article`
  position: relative;
  transform: translateZ(0);
  margin-top: ${em(13)};
  margin-bottom: ${em(22)};
  border: 1px solid ${p => p.theme.colors.blackOp1};
  border-radius: ${p => p.theme.blocks.blockBorderRadius};
  height: ${em(362)};
  overflow: auto;
  padding: ${em(20)} ${em(38)} 0 ${em(20)};

  ${p => p.theme.mq.upMd} {
    height: ${em(321)};
    margin-bottom: ${em(46)};
  }

  a {
    word-break: break-all;
  }
`

export const RulesEnd = styled.div`
  padding-bottom: ${em(38)};
`

export const Article = styled.article`
  margin-top: ${em(20)};
`

export const Title = styled.h4`
  margin-top: ${em(20)};
`

export const TextLHStyled = styled(TextLH)`
  ${({ theme, isDisabled }) => isDisabled && `color: ${theme.colors.blackOp2};`}
`
